import React, { useContext } from 'react';
import { FetchContext } from '../../../../contexts';
import { useAggregatedState } from '../../../../../helpers';

export const LogisticsContext = React.createContext(null);

const { Provider } = LogisticsContext;
export const LogisticsProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
    });

    return (
        <Provider value={{
            state
        }}>
            {props.children}
        </Provider>
    );
}